module.exports = __webpack_public_path__ + "static/media/Ballerina.c5aedfa4.jpg";